module.exports = __webpack_public_path__ + "img/homePageScreen11.08d78cc4.png";